import { sha3_512 } from 'js-sha3';

export function onlyDigits(input) {
  return input.replaceAll(/\D/g, '');
}

// Hashed in the browser so the raw national register number never reaches the server.
export function hashRRN(input) {
  const digits = onlyDigits(input);
  return digits ? sha3_512(digits) : '';
}
